import { useState } from 'react';
import { toast } from 'sonner';

import { mensajeDe } from '@/api/errors';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

import { useMisReportes, useMotivosReporte, useReportar } from './queries';

/** "Creo que este caso necesita revisión": registra un reporte y muestra los anteriores. */
export function ReportarPregunta({
  questionId,
  onClose,
}: {
  questionId: number | null;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={questionId !== null}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DialogContent className="max-h-[90vh] max-w-xl overflow-y-auto">
        <DialogTitle>Reportar este caso</DialogTitle>
        <DialogDescription>
          Cuéntanos qué encontraste; el equipo académico lo revisará.
        </DialogDescription>
        {questionId !== null && <Formulario questionId={questionId} onClose={onClose} />}
      </DialogContent>
    </Dialog>
  );
}

function Formulario({ questionId, onClose }: { questionId: number; onClose: () => void }) {
  const motivos = useMotivosReporte();
  const mios = useMisReportes(questionId);
  const reportar = useReportar(questionId);
  const [motivo, setMotivo] = useState<number | null>(null);
  const [comentario, setComentario] = useState('');
  const elegido = motivo ?? motivos.data?.[0]?.key ?? 0;
  const requiereTexto = elegido === 0;

  return (
    <form
      className="mt-4 space-y-3"
      onSubmit={(e) => {
        e.preventDefault();
        reportar.mutate(
          { issueKey: elegido, comment: comentario },
          {
            onSuccess: () => {
              toast.success('Enviamos tu reporte. ¡Gracias por ayudarnos a mejorar!');
              onClose();
            },
            onError: (er) => toast.error(mensajeDe(er)),
          },
        );
      }}
    >
      <label className="block text-sm font-bold">
        Motivo
        <select
          className="input-vidrio mt-1 w-full"
          value={elegido}
          onChange={(e) => setMotivo(Number(e.target.value))}
        >
          {(motivos.data ?? []).map((m) => (
            <option key={m.key} value={m.key}>
              {m.description}
            </option>
          ))}
          {!motivos.data?.some((m) => m.key === 0) && <option value={0}>Otro</option>}
        </select>
      </label>
      <label className="block text-sm font-bold">
        Comentario {requiereTexto ? '(mínimo 10 caracteres)' : '(opcional)'}
        <textarea
          className="input-vidrio mt-1 min-h-24 w-full font-normal"
          maxLength={2000}
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
        />
      </label>
      <div className="text-right">
        <button
          type="submit"
          className="btn-cs btn-primario"
          disabled={reportar.isPending || (requiereTexto && comentario.trim().length < 10)}
        >
          Enviar reporte
        </button>
      </div>
      {mios.data && mios.data.length > 0 && (
        <div>
          <h3 className="text-sm font-extrabold">Tus reportes anteriores de este caso</h3>
          <ul className="mt-2 space-y-2 text-sm">
            {mios.data.map((r) => (
              <li
                key={r.id}
                className="superficie-lectura flex items-start justify-between gap-3 p-3"
              >
                <span>{r.comment}</span>
                <span
                  className={
                    r.status === 'reviewed' ? 'font-bold text-verde-texto' : 'text-texto-3'
                  }
                >
                  {r.status === 'reviewed' ? 'Revisado' : 'Pendiente'}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </form>
  );
}
